export default {
  // API
  SET_NETWORKS(state, networks) {
    state.networks = networks
  },

  SET_NETWORK_DOMAINS(state, domains) {
    state.domains = domains
  },

  SET_BACKEND_SETS(state, sets) {
    state.backend_sets = sets
  },

  ADD_NETWORK(state, network) {
    state.networks.unshift(network)
  },

  ADD_DOMAIN(state, domain) {
    state.domains.unshift(domain)
  },

  UPDATE_NETWORK(state, network) {
    const networkIndex = state.networks.findIndex(t => t.id === network.id)
    Object.assign(state.networks[networkIndex], network)
  },

  UPDATE_NETWORK_DOMAIN(state, domain) {
    const domainIndex = state.domains.findIndex(t => t.id === domain.id)
    Object.assign(state.domains[domainIndex], domain)
  },
  REMOVE_DOMAIN(state, domainID) {
    const ItemIndex = state.domains.findIndex((p) => p.id === domainID)
    state.domains.splice(ItemIndex, 1)
  },
  UPDATE_SELECTED_BACKEND_SET(state, backendSet) {
    state.selected_backend_set = backendSet;
  },
  SET_TUNNELS(state, tunnels) {
    state.tunnels = tunnels
  },
  SET_TUNNEL_LOCATIONS(state, tunnel_locations) {
    state.tunnel_locations = tunnel_locations
  },
  ADD_TUNNEL(state, tunnel) {
    state.tunnels.unshift(tunnel)
  },
  REMOVE_TUNNEL(state, entry_id) {
    const ItemIndex = state.tunnels.findIndex((p) => p.id === entry_id)
    state.tunnels.splice(ItemIndex, 1)
  },
  UPDATE_TUNNEL(state, tunnel) {
    const tunnelIndex = state.tunnels.findIndex(t => t.id === tunnel.id)
    Object.assign(state.tunnels[tunnelIndex], tunnel)
  },
  SET_CERTIFICATES(state, certificates) {
    state.certificates = certificates
  },
  SET_CERTIFICATE_SUGGESTIONS(state, suggestions) {
    state.certificate_suggestions = suggestions
  },
  ADD_CERTIFICATE(state, certificate) {
    state.certificates.unshift(certificate)
  },
  UPDATE_CERTIFICATE(state, certificate) {
    const index = state.certificates.findIndex((c) => c.id === certificate.id)
    // unknown ids are ignored (e.g. a late poll after delete); ADD_CERTIFICATE creates
    if (index === -1) return
    // replace (not Object.assign) so removed keys like last_error clear too
    state.certificates.splice(index, 1, certificate)
  },
  REMOVE_CERTIFICATE(state, cert_id) {
    const index = state.certificates.findIndex((c) => c.id === cert_id)
    if (index !== -1) {
      state.certificates.splice(index, 1)
    }
  },
}
